/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CreateOrganizationDto,
  CreateOrganizationResultDto,
  MessageResponseDto,
  OrganizationDetailResponseDto,
  OrganizationResponseDto,
  UpdateOrganizationDto,
} from '.././models';

import { authFetch } from '../../../../lib/api';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Creates a new organization with a default client (same name as org) and adds the creator as owner
 * @summary Create a new organization
 */
export const organizationsControllerCreate = (
  createOrganizationDto: CreateOrganizationDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<CreateOrganizationResultDto>(
    {
      url: `/api/organizations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createOrganizationDto,
      signal,
    },
    options
  );
};

export const getOrganizationsControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof organizationsControllerCreate>>,
    TError,
    { data: CreateOrganizationDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof organizationsControllerCreate>>,
  TError,
  { data: CreateOrganizationDto },
  TContext
> => {
  const mutationKey = ['organizationsControllerCreate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof organizationsControllerCreate>>,
    { data: CreateOrganizationDto }
  > = (props) => {
    const { data } = props ?? {};

    return organizationsControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OrganizationsControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof organizationsControllerCreate>>
>;
export type OrganizationsControllerCreateMutationBody = CreateOrganizationDto;
export type OrganizationsControllerCreateMutationError = void;

/**
 * @summary Create a new organization
 */
export const useOrganizationsControllerCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof organizationsControllerCreate>>,
      TError,
      { data: CreateOrganizationDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof organizationsControllerCreate>>,
  TError,
  { data: CreateOrganizationDto },
  TContext
> => {
  const mutationOptions = getOrganizationsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns all organizations that the current user is a member of
 * @summary Get all user's organizations
 */
export const organizationsControllerFindAll = (
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<OrganizationResponseDto[]>(
    { url: `/api/organizations`, method: 'GET', signal },
    options
  );
};

export const getOrganizationsControllerFindAllQueryKey = () => {
  return [`/api/organizations`] as const;
};

export const getOrganizationsControllerFindAllQueryOptions = <
  TData = Awaited<ReturnType<typeof organizationsControllerFindAll>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerFindAll>>, TError, TData>
  >;
  request?: SecondParameter<typeof authFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOrganizationsControllerFindAllQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationsControllerFindAll>>> = ({
    signal,
  }) => organizationsControllerFindAll(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof organizationsControllerFindAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type OrganizationsControllerFindAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof organizationsControllerFindAll>>
>;
export type OrganizationsControllerFindAllQueryError = void;

export function useOrganizationsControllerFindAll<
  TData = Awaited<ReturnType<typeof organizationsControllerFindAll>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerFindAll>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof organizationsControllerFindAll>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOrganizationsControllerFindAll<
  TData = Awaited<ReturnType<typeof organizationsControllerFindAll>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerFindAll>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof organizationsControllerFindAll>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOrganizationsControllerFindAll<
  TData = Awaited<ReturnType<typeof organizationsControllerFindAll>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerFindAll>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all user's organizations
 */

export function useOrganizationsControllerFindAll<
  TData = Awaited<ReturnType<typeof organizationsControllerFindAll>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerFindAll>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getOrganizationsControllerFindAllQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get details of a specific organization (requires membership)
 * @summary Get organization by ID
 */
export const organizationsControllerFindOne = (
  orgId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<OrganizationDetailResponseDto>(
    { url: `/api/organizations/${orgId}`, method: 'GET', signal },
    options
  );
};

export const getOrganizationsControllerFindOneQueryKey = (orgId?: string) => {
  return [`/api/organizations/${orgId}`] as const;
};

export const getOrganizationsControllerFindOneQueryOptions = <
  TData = Awaited<ReturnType<typeof organizationsControllerFindOne>>,
  TError = void,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerFindOne>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOrganizationsControllerFindOneQueryKey(orgId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationsControllerFindOne>>> = ({
    signal,
  }) => organizationsControllerFindOne(orgId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof organizationsControllerFindOne>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type OrganizationsControllerFindOneQueryResult = NonNullable<
  Awaited<ReturnType<typeof organizationsControllerFindOne>>
>;
export type OrganizationsControllerFindOneQueryError = void;

export function useOrganizationsControllerFindOne<
  TData = Awaited<ReturnType<typeof organizationsControllerFindOne>>,
  TError = void,
>(
  orgId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerFindOne>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof organizationsControllerFindOne>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOrganizationsControllerFindOne<
  TData = Awaited<ReturnType<typeof organizationsControllerFindOne>>,
  TError = void,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerFindOne>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof organizationsControllerFindOne>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOrganizationsControllerFindOne<
  TData = Awaited<ReturnType<typeof organizationsControllerFindOne>>,
  TError = void,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerFindOne>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get organization by ID
 */

export function useOrganizationsControllerFindOne<
  TData = Awaited<ReturnType<typeof organizationsControllerFindOne>>,
  TError = void,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerFindOne>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getOrganizationsControllerFindOneQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update organization details (owner only)
 * @summary Update organization
 */
export const organizationsControllerUpdate = (
  orgId: string,
  updateOrganizationDto: UpdateOrganizationDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<OrganizationDetailResponseDto>(
    {
      url: `/api/organizations/${orgId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateOrganizationDto,
    },
    options
  );
};

export const getOrganizationsControllerUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof organizationsControllerUpdate>>,
    TError,
    { orgId: string; data: UpdateOrganizationDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof organizationsControllerUpdate>>,
  TError,
  { orgId: string; data: UpdateOrganizationDto },
  TContext
> => {
  const mutationKey = ['organizationsControllerUpdate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof organizationsControllerUpdate>>,
    { orgId: string; data: UpdateOrganizationDto }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return organizationsControllerUpdate(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OrganizationsControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof organizationsControllerUpdate>>
>;
export type OrganizationsControllerUpdateMutationBody = UpdateOrganizationDto;
export type OrganizationsControllerUpdateMutationError = void;

/**
 * @summary Update organization
 */
export const useOrganizationsControllerUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof organizationsControllerUpdate>>,
      TError,
      { orgId: string; data: UpdateOrganizationDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof organizationsControllerUpdate>>,
  TError,
  { orgId: string; data: UpdateOrganizationDto },
  TContext
> => {
  const mutationOptions = getOrganizationsControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete organization and all related data (clients, members, etc.) - owner only
 * @summary Delete organization
 */
export const organizationsControllerRemove = (
  orgId: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<MessageResponseDto>(
    { url: `/api/organizations/${orgId}`, method: 'DELETE' },
    options
  );
};

export const getOrganizationsControllerRemoveMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof organizationsControllerRemove>>,
    TError,
    { orgId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof organizationsControllerRemove>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationKey = ['organizationsControllerRemove'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof organizationsControllerRemove>>,
    { orgId: string }
  > = (props) => {
    const { orgId } = props ?? {};

    return organizationsControllerRemove(orgId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OrganizationsControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof organizationsControllerRemove>>
>;

export type OrganizationsControllerRemoveMutationError = void;

/**
 * @summary Delete organization
 */
export const useOrganizationsControllerRemove = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof organizationsControllerRemove>>,
      TError,
      { orgId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof organizationsControllerRemove>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationOptions = getOrganizationsControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
